var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 46.6797L25.0391 32.3633L0.0390625 46.8359L50 46.6797Z",
    fill: "#662D91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.16406L24.8438 32.3633L50 46.6797L25 3.16406Z",
    fill: "#9E1F63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0390625 46.8359L24.9219 32.5977L25 3.16406L0.0390625 46.8359Z",
    fill: "#FF5000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8438 20.918L14.7852 38.2422H35.1758L24.8438 20.918Z",
    fill: "white",
    stroke: "#FF5000",
    strokeWidth: 0.83,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6e44f91737fab5144c863fa62bae6520.svg";
export { ForwardRef as ReactComponent };